// extracted by mini-css-extract-plugin
module.exports = {"relogioNumero":"Relogio_relogioNumero__3Tzz4","relogioDivisao":"Relogio_relogioDivisao__fwDbi"};